import { connect } from 'react-redux'
import { getCanIds } from 'selectors/feature/inputs'
import { setCanId } from 'actions/feature/outputs'
import { updateTemSwitchCustomDescription } from 'actions/feature/inputs'
import { bindActionCreators } from 'redux'
import CanIdEditor from './CanIdEditor.jsx'

const mapStateToProps = (state) => ({
  featureCanIds: getCanIds(state),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setCanId, updateTemSwitchCustomDescription }, dispatch)

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  const { featureCanIds } = propsFromState
  const { setCanId, updateTemSwitchCustomDescription } = propsFromDispatch
  const { canId } = ownProps
  return {
    ...ownProps,
    featureCanIds,
    setCanId: (value) => {
      const valueUpperCased = value.toUpperCase()
      if (canId !== valueUpperCased) {
        setCanId(ownProps.uri, valueUpperCased)
        updateTemSwitchCustomDescription(ownProps.uri, null)
      }
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CanIdEditor)
